import { createFileRoute } from "@tanstack/react-router";
import HowInsuranceWorks from "@/pages/HowInsuranceWorks";
export const Route = createFileRoute("/how-insurance-works")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "How Insurance Works | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "How insurance covers TMS, SAINT TMS, SPRAVATO, and ketamine. Learn about prior auth, medical necessity, and free benefits verification in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "How Insurance Works | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "How insurance covers TMS, SAINT TMS, SPRAVATO, and ketamine. Learn about prior auth, medical necessity, and free benefits verification in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/how-insurance-works",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/how-insurance-works",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HowInsuranceWorks />;
}
